import { Routes } from '@angular/router';
import { canActivateTeam } from './guards/role.guard';
import { OnboardingGuard } from './guards/onboarding.guard';
import { authGuard } from './guards/auth.guard';
import { analyticsGuard } from './guards/analytics.guard';
export const routes: Routes = [
  {
    path: 'organizations',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/organizations/organization-list/organization-list.component').then(
            (m) => m.OrganizationListComponent,
          ),
        data: {
          title: 'Organization List',
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Organizations', routerLink: '/organizations/list' },
          ],
        },
      },
      {
        path: 'demo-requests',
        loadComponent: () =>
          import('./pages/organizations/organization-demo-requests/organization-demo-requests.component').then(
            (m) => m.OrganizationDemoRequestsComponent,
          ),
        data: {
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            {
              label: 'Demo Requests',
              routerLink: '/organizations/demo-requests',
            },
          ],
          title: 'Organization Demo Requests',
        },
      },
    ],
  },
  {
    path: 'anti-counterfeit-requests',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/anti-counterfeit-requests/anti-counterfeit-requests-list/anti-counterfeit-requests-list.component').then(
            (m) => m.AntiCounterfeitRequestsListComponent,
          ),
        data: {
          title: 'Anti-Counterfeit QR Requests',
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            {
              label: 'Anti-Counterfeit QR Requests',
              routerLink: '/anti-counterfeit-requests/list',
            },
          ],
        },
      },
    ],
  },
  {
    path: 'groups',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/groups/group-list/group-list.component').then(
            (m) => m.GroupListComponent,
          ),
        data: {
          title: 'Group & Vendor List',
          requiredPermissions: ['show-menu-vendor'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Groups & Vendors', routerLink: '/groups/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'resources',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/resources/farmer-list/farmer-list.component').then(
            (m) => m.FarmerListComponent,
          ),
        data: {
          title: 'Farmer List',
          requiredPermissions: ['show-menu-resources'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Resources', routerLink: '/resources/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'recall-management',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/recall-management/recall-dashboard/recall-dashboard.component').then(
            (m) => m.RecallDashboardComponent,
          ),
        data: {
          title: 'Recall Dashboard',
          requiredPermissions: ['show-menu-recall-product'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Recall Management', routerLink: '/recall-management' },
            {
              label: 'Recall Dashboard',
              routerLink: '/recall-management/dashboard',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/recall-management/recall-list/recall-list.component').then(
            (m) => m.RecallListComponent,
          ),
        data: {
          title: 'Recall Product List',
          requiredPermissions: ['show-menu-recall-product'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Recall Management', routerLink: '/recall-management' },
            { label: 'Recall Product', routerLink: '/recall-management/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'request-list',
        loadComponent: () =>
          import('./pages/recall-management/recall-request-list/recall-request-list.component').then(
            (m) => m.RecallRequestListComponent,
          ),
        data: {
          title: 'Recall Product Request List',
          requiredPermissions: ['show-menu-recall-product'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Recall Management', routerLink: '/recall-management' },
            {
              label: 'Recall Product Requests',
              routerLink: '/recall-management/request-list',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'users',
    canActivate: [authGuard],
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/users/user-list/user-list.component').then((m) => m.UserListComponent),
        data: {
          title: 'User List',
          requiredPermissions: ['list-user'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Users', routerLink: '/users/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('./pages/users/admin-user-list/admin-user-list.component').then(
            (m) => m.AdminUserListComponent,
          ),
        data: {
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Admin Users', routerLink: '/users/admin' },
          ],
          title: 'Admin User List',
        },
      },
    ],
  },
  {
    path: 'subscription',
    canActivate: [authGuard],
    children: [
      {
        path: 'plans',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/subscription/plans/plans.component').then((m) => m.PlansComponent),
            data: {
              title: 'Subscription Plans',
              requiredPermissions: ['view-subscription'],
            },
            canActivate: [canActivateTeam],
          },
          {
            path: 'subscribe/:id',
            loadComponent: () =>
              import('./pages/subscription/subscribe/subscribe.component').then(
                (m) => m.SubscribeComponent,
              ),
            data: {
              title: 'Subscribe',
              requiredPermissions: ['create-subscription'],
            },
            canActivate: [canActivateTeam],
          },
        ],
      },
    ],
  },
  {
    path: 'public-experiences',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'active', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/public-experiences/public-experience-list/public-experience-list').then(
            (m) => m.PublicExperienceList,
          ),
        data: {
          title: 'Public Experience List',
          requiredPermissions: ['show-menu-product'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Public Experiences', routerLink: '/public-experiences' },
            { label: 'List', routerLink: '/public-experiences/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'products',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/products/product-list/product-list.component').then(
            (m) => m.ProductListComponent,
          ),
        data: {
          title: 'Product List',
          requiredPermissions: ['show-menu-product'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Product Management', routerLink: '/product-management' },
            { label: 'Products', routerLink: '/products/list' },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'data',
        loadComponent: () =>
          import('./pages/products/product-item-data-list/product-item-data-list.component').then(
            (m) => m.ProductItemDataListComponent,
          ),
        data: {
          title: 'Product Item Data List',
          requiredPermissions: ['list-product-data'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Product Management', routerLink: '/product-management' },
            { label: 'Product Item Data', routerLink: '/products/data' },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'scan-qr',
        loadComponent: () =>
          import('./pages/products/scan-qr-code-page/scan-qr-code-page.component').then(
            (m) => m.ScanQrCodePageComponent,
          ),
        data: {
          title: 'Scan QR Code',
          requiredPermissions: ['scan-product-data'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'QR Data Capture', routerLink: '/products/scan-qr' },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'traceability/:id',
        loadComponent: () =>
          import('./pages/products/traceability-explorer/traceability-explorer.component').then(
            (m) => m.TraceabilityExplorerComponent,
          ),
        data: {
          title: 'Traceability Explorer',
          requiredPermissions: ['list-product-data'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            { label: 'Traceability Ledger', routerLink: '/dashboards/traceability' },
            { label: 'Traceability Explorer', routerLink: '/products/traceability/:id' },
          ],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'reports',
    data: {
      requiredPermissions: ['show-menu-reporting'],
    },
    canActivate: [authGuard, canActivateTeam],
    children: [
      { path: '', redirectTo: 'customized/list', pathMatch: 'full' },
      {
        path: 'customized',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/reporting/custom-reports/list/list.component').then(
                (m) => m.ListComponent,
              ),
            data: {
              title: 'Customized Reports List',
              requiredPermissions: ['show-menu-reporting'],
              breadcrumbs: [
                { label: 'Home', routerLink: '/home' },
                { label: 'Reports', routerLink: '/reports/customized/list' },
              ],
            },
            canActivate: [canActivateTeam],
          },
          {
            path: 'view/:id',
            loadComponent: () =>
              import('./pages/reporting/custom-reports/view/view.component').then(
                (m) => m.ViewComponent,
              ),
            data: {
              requiredPermissions: ['show-menu-reporting'],
              breadcrumbs: [
                { label: 'Home', routerLink: '/home' },
                { label: 'Reports', routerLink: '/reports/customized/list' },
                {
                  label: 'View',
                  routerLink: '/reports/customized/view/:id',
                },
              ],
            },
            canActivate: [canActivateTeam],
          },
        ],
      },
      {
        path: 'static',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/reporting/static-reports/static-report-list/static-report-list.component').then(
                (m) => m.StaticReportListComponent,
              ),
            data: {
              title: 'Static Reports List',
              requiredPermissions: ['show-menu-reporting'],
              breadcrumbs: [
                { label: 'Home', routerLink: '/home' },
                { label: 'Reports', routerLink: '/reports/list' },
              ],
            },
            canActivate: [canActivateTeam],
          },
        ],
      },
    ],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
    data: {
      title: 'Settings',
      breadcrumbs: [
        { label: 'Home', routerLink: '/home' },
        { label: 'Settings', routerLink: '/settings' },
      ],
      requiredPermissions: ['list-cte-kde', 'list-role', 'view-subscription'],
    },
    canActivate: [authGuard, canActivateTeam],
    children: [
      { path: '', redirectTo: 'profile-security', pathMatch: 'full' },
      {
        path: 'payment-methods',
        loadComponent: () =>
          import('./pages/settings/payment-methods/payment-methods.component').then(
            (m) => m.PaymentMethodsComponent,
          ),
      },
      {
        path: 'organization-settings',
        loadComponent: () =>
          import('./pages/settings/organization-settings/organization-settings').then(
            (m) => m.OrganizationSettings,
          ),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/settings/roles/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'profile-security',
        loadComponent: () =>
          import('./pages/settings/profile-security/profile-security.component').then(
            (m) => m.ProfileSecurityComponent,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/settings/notifications/notifications.component').then(
            (m) => m.NotificationsComponent,
          ),
      },
      {
        path: 'ctes-kdes',
        loadComponent: () =>
          import('./pages/settings/ctes-kdes/ctes-kdes.component').then((m) => m.CtesKdesComponent),
      },
      {
        path: 'api-keys',
        loadComponent: () =>
          import('./pages/settings/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
      },
      {
        path: 'printers',
        loadComponent: () =>
          import('./pages/settings/printers/printers.component').then((m) => m.PrintersComponent),
      },
      {
        path: 'integrations',
        loadComponent: () =>
          import('./pages/settings/integrations/integrations').then((m) => m.IntegrationsComponent),
      },
      {
        path: 'subdomain',
        loadComponent: () =>
          import('./pages/settings/subdomain/subdomain').then((m) => m.SubdomainComponent),
      },
    ],
  },
  {
    path: 'home',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
        data: {
          title: 'Home',
          breadcrumbs: [{ label: 'Home', routerLink: '/home' }],
        },
      },
    ],
  },
  {
    path: 'talking-avatar-demo',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/talking-avatar-demo/talking-avatar-demo.component').then(
        (m) => m.TalkingAvatarDemoComponent,
      ),
    data: {
      title: '3D Talking Avatar Demo',
      breadcrumbs: [
        { label: 'Home', routerLink: '/home' },
        { label: 'Talking Avatar Demo', routerLink: '/talking-avatar-demo' },
      ],
    },
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding').then((m) => m.Onboarding),
    canActivate: [authGuard, OnboardingGuard],
    data: {
      title: 'Onboarding',
      breadcrumbs: [
        { label: 'Home', routerLink: '/home' },
        { label: 'Onboarding', routerLink: '/onboarding' },
      ],
    },
  },
  {
    path: 'dashboard',
    data: {
      requiredPermissions: ['show-menu-dashboard'],
    },
    canActivate: [authGuard, canActivateTeam],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboards/scan-statistics/scan-statistics.component').then(
            (m) => m.ScanStatistics,
          ),
        data: {
          title: 'Dashboard',
          requiredPermissions: ['tracking-dashboard'],
        },
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'analytics',
    data: {
      requiredPermissions: ['show-menu-dashboard'],
    },
    canActivate: [authGuard, canActivateTeam, analyticsGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboards/page-views/page-views').then((m) => m.PageViews),
        data: {
          title: 'Analytics',
          requiredPermissions: ['tracking-dashboard'],
        },
        canActivate: [canActivateTeam, analyticsGuard],
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          {
            path: 'overview',
            loadComponent: () =>
              import('./pages/dashboards/page-views/overview/overview').then((m) => m.Overview),
          },
          {
            path: 'qr-code',
            loadComponent: () =>
              import('./pages/dashboards/page-views/qr-code/qr-code').then((m) => m.QrCode),
          },
          {
            path: 'public-experience',
            loadComponent: () =>
              import('./pages/dashboards/page-views/public-experience/public-experience').then(
                (m) => m.PublicExperience,
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'dashboards',
    data: {
      requiredPermissions: ['show-menu-dashboard'],
    },
    canActivate: [authGuard, canActivateTeam],
    children: [
      { path: '', redirectTo: 'track-products', pathMatch: 'full' },
      {
        path: 'product-expiration',
        loadComponent: () =>
          import('./pages/dashboards/product-expiration/product-expiration.component').then(
            (m) => m.ProductExpirationComponent,
          ),
        data: {
          title: 'Product Expiration',
          requiredPermissions: ['tracking-dashboard'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            {
              label: 'Product Expiration',
              routerLink: '/dashboards/product-expiration',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'scan-statistics',
        loadComponent: () =>
          import('./pages/dashboards/scan-statistics/scan-statistics.component').then(
            (m) => m.ScanStatistics,
          ),
        data: {
          title: 'Scan Statistics',
          requiredPermissions: ['tracking-dashboard'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            {
              label: 'Scan Statistics',
              routerLink: '/dashboards/scan-statistics',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'track-products',
        loadComponent: () =>
          import('./pages/dashboards/track-products/track-products.component').then(
            (m) => m.TrackDashboardComponent,
          ),
        data: {
          title: 'Track Products',
          requiredPermissions: ['tracking-dashboard'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            {
              label: 'Track Products',
              routerLink: '/dashboards/track-products',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'traceability',
        loadComponent: () =>
          import('./pages/dashboards/traceability-ledger/traceability-ledger.component').then(
            (m) => m.TraceabilityLedgerComponent,
          ),
        data: {
          title: 'Traceability Ledger',
          requiredPermissions: ['tracking-dashboard'],
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            {
              label: 'Traceability Ledger',
              routerLink: '/dashboards/traceability',
            },
          ],
        },
        canActivate: [canActivateTeam],
      },
      {
        path: 'page-views',
        loadComponent: () =>
          import('./pages/dashboards/page-views/page-views').then((m) => m.PageViews),
        data: {
          title: 'Page Views',
          breadcrumbs: [
            { label: 'Home', routerLink: '/home' },
            { label: 'Dashboards', routerLink: '/dashboards' },
            {
              label: 'Page Views',
              routerLink: '/dashboards/page-views',
            },
          ],
          requiredPermissions: ['list-cte-kde', 'list-role', 'view-subscription'],
        },
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          {
            path: 'overview',
            loadComponent: () =>
              import('./pages/dashboards/page-views/overview/overview').then((m) => m.Overview),
          },
          {
            path: 'qr-code',
            loadComponent: () =>
              import('./pages/dashboards/page-views/qr-code/qr-code').then((m) => m.QrCode),
          },
          {
            path: 'public-experience',
            loadComponent: () =>
              import('./pages/dashboards/page-views/public-experience/public-experience').then(
                (m) => m.PublicExperience,
              ),
          },
        ],
        canActivate: [canActivateTeam],
      },
    ],
  },
  {
    path: 'qr',
    canActivate: [authGuard],
    children: [
      {
        path: 'qr-orders',
        children: [
          {
            path: 'list',
            redirectTo: '/qr/qr-codes/list',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'qr-codes',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/qr/qr-code-list/qr-code-list').then((m) => m.QrCodeListComponent),
            data: {
              title: 'QR Code List',
              requiredPermissions: ['list-qr-order'],
              breadcrumbs: [
                { label: 'Dashboard', routerLink: '/home' },
                { label: 'QR Codes', routerLink: '/qr/qr-codes/list' },
              ],
            },
            canActivate: [canActivateTeam],
          },
        ],
      },
    ],
  },

  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'otp',
    loadComponent: () =>
      import('./pages/otppage/otppage.component').then((m) => m.OTPPageComponent),
  },
  {
    path: 'demo',
    loadComponent: () =>
      import('./pages/request-demo/request-demo.component').then((m) => m.RequestDemoPageComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/sign-up-page/sign-up-page.component').then((m) => m.SignUpPageComponent),
  },
  {
    path: 'demo-success',
    loadComponent: () =>
      import('./pages/request-demo-success/request-demo-success.component').then(
        (m) => m.RequestDemoSuccessComponent,
      ),
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('./pages/accept-invitation/accept-invitation').then((m) => m.AcceptInvitation),
  },
  {
    path: 'no-access',
    loadComponent: () =>
      import('./components/shared-components/no-access/no-access.component').then(
        (m) => m.NoAccessComponent,
      ),
  },
];
